module.exports = __webpack_public_path__ + "img/single-property.a76cda9.png";